import { Component } from '@angular/core';
import {
  Subject, takeUntil
} from 'rxjs';

import { BreakpointsService } from '@sondermind/utilities/services';
import { IconColors, IconSizes } from '@sondermindorg/iris-design-system-angular';

@Component({
  selector: 'public-header',
  templateUrl: './public-header.component.html',
  styleUrls: ['./public-header.component.scss'],
})

export class PublicHeaderComponent {
  showMobileMenu: boolean = false;
  showExploreCareMenu: boolean = false;
  isMobile: boolean = false;
  destroyed$ = new Subject<void>();

  iconSizes = IconSizes;
  iconColors = IconColors;

  constructor(
    public breakpointService: BreakpointsService
  ) { }

  ngOnInit(): void {
    this.breakpointService.isMobileOrTablet$.pipe(
      takeUntil(this.destroyed$)
    ).subscribe((isMobileOrTablet) => {
      this.isMobile = isMobileOrTablet;
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  toggleMobileMenu(): void {
    this.showMobileMenu = !this.showMobileMenu;
  }

  toggleExploreCare(): void {
    this.showExploreCareMenu = !this.showExploreCareMenu;
  }
}
